import script from "./Vendors.vue?vue&type=script&setup=true&lang=js"
export * from "./Vendors.vue?vue&type=script&setup=true&lang=js"

import "./Vendors.vue?vue&type=style&index=0&id=a01c3644&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a01c3644"]])

export default __exports__